import { Link } from "react-router-dom";
import { productCategories } from "@/mocks/products";
import { useScrollAnimation, useStaggerAnimation } from "@/hooks/useScrollAnimation";

export default function ProductCategories() {
  const headerAnim = useScrollAnimation();
  const gridAnim = useStaggerAnimation(productCategories.length, { threshold: 0.05 });

  return (
    <section className="bg-[#f5ede4] py-20 md:py-28 overflow-hidden">
      <div className="w-full px-6 md:px-16 max-w-[1400px] mx-auto">
        <div
          ref={headerAnim.ref as React.RefObject<HTMLDivElement>}
          className={`flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-4 transition-all duration-700 ${headerAnim.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <div>
            <p className="text-[#8B5E52] text-[1rem] tracking-[0.25em] uppercase font-medium mb-3">Collections</p>
            <h2 className="text-[#3d2b1f] text-[2.125rem] md:text-[2.5rem] font-bold leading-[1.4]">商品分類</h2>
          </div>
          <Link to="/shop" className="inline-flex items-center gap-2 text-[#8B5E52] text-[1.0625rem] font-medium hover:gap-3 transition-all cursor-pointer whitespace-nowrap">
            查看所有商品 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div
          ref={gridAnim.ref as React.RefObject<HTMLDivElement>}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4"
        >
          {productCategories.map((cat, i) => (
            <Link
              key={cat.id}
              to={`/shop?category=${cat.id}`}
              className={`group block rounded-lg overflow-hidden cursor-pointer transition-all duration-700 ${gridAnim.visibleItems[i] ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-8 scale-95"}`}
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-108"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#3d2b1f]/70 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-3 text-center">
                  <p className="text-white text-[1rem] font-semibold leading-tight">{cat.name}</p>
                  <p className="text-white/75 text-[0.875rem] mt-0.5">{cat.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
